<div class="header-container">
  <div>
    @if (menu.translateName || overrideTranslateName) {
      <h2 class="has-padding-horizontal-30px">{{(overrideTranslateName ||'CUSTOMIZER.COMPONENTS.' + menu.translateName + '.NAME') | translate}}</h2>
    }
    @if (menu.translateDescription && showTranslateDecription) {
      <div class="has-padding-horizontal-30px" [innerHTML]="menu.translateDescription | translate"></div>
    }
    <div>
      <ng-content select="[additional]"></ng-content>
    </div>
  </div>
  <div class="content" [ngClass]="className">
    <ng-content select="[main]"></ng-content>
  </div>
</div>